<template>
  <div class="index_home">

    <IndxHead></IndxHead>
    <div class="w100" style="height: 800px;">
      <section>
        <!-- 全屏Banner容器 -->
        <div class="banner">
          <!-- 幻灯片容器 -->
          <div class="slides">
            <!-- 幻灯片1 -->
            <div class="slide" :class="{
              active: currentSlide === 0
            }">
              <div class="slide-bg index-img"></div>
              <div class="content">
                <h2><span>道</span>行天下 <span>信</span>义为本</h2>
                <p>新科技、新材料、新能源、新业态</p>

              </div>
            </div>

            <!-- 幻灯片2 -->
            <div class="slide" :class="{
              active: currentSlide === 1
            }">
              <div class="slide-bg index-img3"></div>
              <div class="content">
                <h2>行业资源整合</h2>
                <p>技术创新引领行业潮流</p>

              </div>
            </div>

            <!-- 幻灯片3 -->
            <div class="slide" :class="{
              active: currentSlide === 2
            }">
              <div class="slide-bg index-img1"></div>
              <div class="content">
                <h2>成就客户 共创美好</h2>
                <p>以客户为中心 合作共赢</p>

              </div>
            </div>
          </div>

          <!-- 导航按钮 -->
          <button class="nav-btn prev" @click="prevSlide">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="nav-btn next" @click="nextSlide">
            <i class="fas fa-chevron-right"></i>
          </button>

          <!-- 指示器 -->
          <div class="indicators">
            <div v-for="(slide, index) in 3" :key="index" class="indicator" :class="{ active: currentSlide === index }"
              @click="goToSlide(index)"></div>
          </div>
        </div>
      </section>

      <section class="about_section">
        <div style="height: 750px;" class="w1024">

          <div class="d-flex">
            <div class="about_bg">
              <h1 class="text-left pt-50 " style="font-size: 30px;">关于<span class="color-1">道信</span></h1>
              <p class="line-block"></p>
              <p class="text-uppercase text-left" style="font-size: 16px; color: #cccccc;margin-top: 10px;">company
                profile</p>
              <div class="text-justify fs-14" style="line-height:2;margin-top: 20px; color: #000;">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京道信资产管理有限公司于2016年3月成立，总部位于北京市海淀区中关村高新技术核心区，具有得天独厚的区位优势，能够快速捕捉前沿信息与创新资源。
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司始终秉持“厚德、融合、成长”的投资理念，注重跨行业资源整合，助力企业健康快速成长，覆盖教育、科技、现代农业、矿业、环保、新能源、新材料、建设工程、文旅、大健康等多个极具发展潜力的投资领域。
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;凭借专业的投资团队和精准的市场洞察力，公司已成功投运项目50多个。目前，在投运营管理规模超过30亿元，展现出强劲的实力与卓越的运营管理能力，在行业中树立了良好的口碑与典范。
              </div>

              <div class="d-flex space-between" style="margin-top: 70px;">
                <div class="text-left" style="width: 230px; ">

                  <count-to ref="count1" :start-val="2000" :end-val="2016" separator="" :duration="3000"
                    :autoplay="false" class="color-1 wf-b fs-60" />
                  <span>年</span>

                  <div>道信资产成立</div>
                </div>
                <div style="width: 1px;height: auto;background-color: #c1c1c1; position:relative;">
                  <div style="width: 1px;height: 40px;background-color: #0547c2;position:absolute;top:0;left:0"></div>
                </div>
                <div class="text-left" style="width: 140px; padding-left: 20px; ">
                  <count-to ref="count2" :start-val="0" :end-val="50" :duration="1200" :autoplay="false"
                    class="color-1 wf-b fs-60" />
                  <span>个</span>
                  <div>成功投运项目</div>

                </div>
                <div style="width: 1px;height: auto;background-color: #c1c1c1;position:relative;">
                  <div style="width: 1px;height: 40px;background-color: #0547c2;position:absolute;top:0;left:0"></div>
                </div>
                <div class="text-left" style="width: 140px;  padding-left: 20px;">
                  <count-to ref="count3" :start-val="0" :end-val="30" :duration="1200" :autoplay="false"
                    class="color-1 wf-b fs-60" />
                  <span>亿</span>
                  <div>运营管理规模</div>

                </div>

              </div>
            </div>
            <div class="pt-50">
              <img :src="abouts" alt="" style="width:580px;" @click="moreAbout()">
            </div>
          </div>

        </div>
      </section>

      <section>
        <div class="text-center">

          <h1 class="pt-50 " style="font-size: 30px;">业务<span class="color-1">领域</span></h1>
          <p class="line-block" style="margin:auto"></p>

          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">Business Area</p>

        </div>

        <div class="d-flex w100 space-between pt-50">
          <div class="text-center modle molde-1" @click="goToBrand('education')">
            <div class="modle-bg"></div>
            <div class="modle-overlay">
              <img :src="fimg1" alt="">
              <h2>教育领域</h2>
              <div class="upper">Educational Field</div>
              <p><a href="#" class="bth" @click.prevent="goToBrand('education')">查看详情</a></p>
            </div>
            <div class="color-overlay"></div>
          </div>
          <div class="text-center  modle molde-2" @click="goToBrand('agriculture')">
            <div class="modle-bg"></div>
            <div class="modle-overlay">
              <img :src="fimg2" alt="">
              <h2>现代农业</h2>
              <div class="upper">Modern Agriculture</div>
              <p><a href="#" class="bth" @click.prevent="goToBrand('agriculture')">查看详情</a></p>
            </div>
            <div class="color-overlay"></div>

          </div>
          <div class="text-center modle molde-3" @click="goToBrand('ai')">
            <div class="modle-bg"></div>
            <div class="modle-overlay">
              <img :src="fimg3" alt="">
              <h2>人工智能领域</h2>
              <div class="upper">Artificial Intelligence Field</div>
              <p><a href="#" class="bth" @click.prevent="goToBrand('ai')">查看详情</a></p>
            </div>
            <div class="color-overlay"></div>
          </div>
          <div class="text-center modle molde-4" @click="goToBrand('healthcare')">
            <div class="modle-bg"></div>
            <div class="modle-overlay">
              <img :src="fimg4" alt="">
              <h2>大健康领域</h2>
              <div class="upper">Healthcare Industry</div>
              <p><a href="#" class="bth" @click.prevent="goToBrand('healthcare')">查看详情</a></p>
            </div>
            <div class="color-overlay"></div>

          </div>
        </div>
      </section>
      <!--  -->

      <section class="team_bg">
        <div>

          <h1 class="pt-100 " style="font-size: 30px;">核心<span class="color-1">团队</span></h1>
          <p class="line-block" style="margin:auto"></p>

          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">core team</p>

        </div>
        <div class="d-flex w1024 space-between pt-100">

          <div>

            <div class="w100">
            </div>
            <div class="rencaiBj">
              <img :src="rc166" style="width:190px " @click="moreRc" />
            </div>
          </div>

          <div>

            <div class="rencaiBj">
              <img :src="rc2" style="width:192px " @click="moreRc" />
            </div>
          </div>
          <div>

            <div class="rencaiBj">
              <img :src="rc3" style="width:190px " @click="moreRc" />
            </div>

          </div>

          <div>

            <div class="w100">
            </div>
            <div class="rencaiBj">
              <img :src="rc1" style="width:208px " @click="moreRc" />
            </div>
          </div>
        </div>

        <div class="more_team">
          <a href="#" @click="moreRc">更多团队</a>
        </div>
      </section>
      <!--  -->

      <section class="w100 interBg">
        <div style="color:#ffffff">

          <h1 class="pt-100 " style="font-size: 30px;">发展<span>布局</span></h1>
          <p class="line-block" style="margin:auto;background:#ffffff;"></p>

          <p class="text-uppercase " style="font-size: 16px;  margin-top: 10px;">Development Layout</p>


        </div>

        <div class="w1024 pt-100">
          <div class="d-flex  space-around ">
            <div class="text-center" @click="goToBrands('one')">
              <div class="d-flex flex-column com-bg1 color-fff">
                <div class="content-bg">
                  <div><img :src="fourImg1" alt=""></div>
                  <div>新能源</div>
                  <div>New Energy</div>
                </div>
              </div>
              <div class="color-fff fs-14 pt-30 plr20">
                为抢占能源制高点，道信资本积极布局新能源产业，包括风能、光伏、水电、氢能的系统化能源体系...
              </div>
            </div>
            <div @click="goToBrands('two')">
              <div class="d-flex flex-column com-bg1 color-fff">
                <div class="content-bg">
                  <div><img :src="fourImg2" alt=""></div>
                  <div>新材料</div>
                  <div>New Materials</div>
                </div>
              </div>
              <div class="color-fff fs-14 pt-30 plr20">
                新材料是国民经济发展的基础，道信资本积极布局新材料赛道，投资建设煤研石综合利用碳产业链绿色产业园...
              </div>
            </div>
            <div @click="goToBrands('thress')">
              <div class="d-flex flex-column com-bg1 color-fff">
                <div class="content-bg">
                  <div><img :src="fourImg4" alt=""></div>
                  <div>矿业</div>
                  <div>Mineral</div>
                </div>
              </div>
              <div class="color-fff fs-14 pt-30 plr20">
                矿业资源是未来财富的象征，道信资本积极布局矿业资源开发项目，已在鄂东南地区重点推进白云岩...
              </div>
            </div>
            <div @click="goToBrands('four')">
              <div class="d-flex flex-column com-bg1 color-fff">
                <div class="content-bg">
                  <div><img :src="fourImg3" alt=""></div>
                  <div>新科技</div>
                  <div>New Technology</div>
                </div>
              </div>
              <div class="color-fff fs-14 pt-30 plr20">
                道信资本紧盯科技前沿，聚焦光通信、智能物联、域控智驱等产业化落地新科技项目，助力产业化和规模化拓展，提升科技...
              </div>
            </div>


          </div>
        </div>

      </section>
      <!--  -->
      <section class="parter_bg pt-50">
        <div>

          <h1 class="pt-50 " style="font-size: 30px;">合作<span class="color-1">伙伴</span></h1>
          <p class="line-block" style="margin:auto"></p>

          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;"> Cooperative Partner</p>


        </div>
        <div class="w1024 pt-50">
          <div class="d-flex " style="flex-wrap: wrap; ">
            <div v-for="(items, index) in dataImg" :key="index" class="caseImg">
              <img :src="items.img" alt="" class="imgCase">
            </div>
          </div>
        </div>
      </section>
      <!--  -->
      <section>

        <IndxFoot></IndxFoot>
      </section>
    </div>
  </div>
</template>

<script>
import img1 from '@/images/case1.png'
import img2 from '@/images/case2.png'
import img3 from '@/images/case3.png'
import img4 from '@/images/case4.png'
import img5 from '@/images/case5.png'
import img6 from '@/images/case6.png'
import img7 from '@/images/case7.png'
import img8 from '@/images/case8.png'
import img9 from '@/images/case9.png'
import img10 from '@/images/case10.png'
import img11 from '@/images/case11.png'
import img12 from '@/images/case12.png'
import img13 from '@/images/case13.png'
import img14 from '@/images/case14.png'
import img15 from '@/images/case15.png'
import img16 from '@/images/case16.png'
import img17 from '@/images/case17.png'
// import img18 from '@/images/case18.png'
import case19 from '@/images/case19.png'
import rc1s from '@/images/rc1.png'
import rc2s from '@/images/rc2.png'
import rc3s from '@/images/rc3.png'

import rc166 from '@/images/rc166.png'

import fimg4s from '@/images/f-4.png'
import fimg3s from '@/images/f3.png'
import fimg2s from '@/images/f2.png'
import fimg1s from '@/images/f-1.png'
import fourImg1s from '@/images/four44.png'
import fourImg2s from '@/images/four33.png'
import fourImg4s from '@/images/four22.png'
import fourImg3s from '@/images/four11.png'
import CountTo from 'vue-count-to'
import IndxHead from '@/components/IndxHead.vue'
import IndxFoot from '@/components/IndxFoot.vue'
import aboutsimg from "@/images/abouts.png"
export default {
  name: 'HomePage',
  components: {
    IndxHead,
    IndxFoot,
    CountTo
  },
  data() {
    return {
      rc1: rc1s,
      rc2: rc2s,
      rc3: rc3s,
      rc166: rc166,
      dataImg: [
        { img: img1 },
        { img: img2 },
        { img: img3 },
        { img: img4 },
        { img: img5 },
        { img: img6 },
        { img: img7 },
        { img: img8 },
        { img: img9 },
        { img: img10 },
        { img: img11 },
        { img: img12 },
        { img: img13 },
        { img: img14 },
        { img: img15 },
        { img: img16 },
        { img: img17 },
        // { img: img18 },
        { img: case19 }


      ],
      fourImg1: fourImg1s,
      fourImg2: fourImg2s,
      fourImg3: fourImg3s,
      fourImg4: fourImg4s,
      fimg4: fimg4s,
      fimg3: fimg3s,
      fimg2: fimg2s,
      fimg1: fimg1s,
      abouts: aboutsimg,
      currentSlide: 0,
      totalSlides: 3,
      autoPlayInterval: null,

    }
  },
  mounted() {
    this.startAutoPlay();
    document.addEventListener('keydown', this.handleKeydown);
    const banner = this.$el.querySelector('.banner');
    if (banner) {
      banner.addEventListener('mouseenter', this.pauseAutoPlay);
      banner.addEventListener('mouseleave', this.startAutoPlay);
    }

    // 添加Intersection Observer来监听关于部分
    this.setupAboutSectionObserver();
    this.detectDevice()
  },
  beforeUnmount() {
    this.pauseAutoPlay();
    document.removeEventListener('keydown', this.handleKeydown);

    // 清理观察器
    if (this.aboutObserver) {
      this.aboutObserver.disconnect();
    }
  },
  methods: {
    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // 移动设备正则表达式
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
      const flgs = mobileRegex.test(userAgent);
      if (flgs) {
        window.location.href = 'https://www.daoxincapital.com/home/'
      }

    },
    goToBrands(section) {
      this.$router.push({
        path: '/energy',
        query: { section: section }
      });
    },
    goToBrand(section) {
      // 跳转到品牌页面，并传递定位参数
      this.$router.push({
        path: '/brand',
        query: { section: section }
      });
    },
    moreAbout() {
      this.$router.push('/about');
    },
    moreRc() {
      this.$router.push('/talent');
    },
    setupAboutSectionObserver() {
      // 创建Intersection Observer
      this.aboutObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // 当关于部分进入视口时
          if (entry.isIntersecting) {
            // 触发计数动画
            this.startCountAnimations();
          }
        });
      }, {
        threshold: 0.3 // 当30%的元素可见时触发
      });

      // 观察关于部分
      const aboutSection = this.$el.querySelector('.about_section');
      if (aboutSection) {
        this.aboutObserver.observe(aboutSection);
      }
    },

    startCountAnimations() {
      // 确保组件已挂载
      this.$nextTick(() => {
        // 重置并启动每个计数动画
        if (this.$refs.count1) {
          this.$refs.count1.start();
        }
        if (this.$refs.count2) {
          this.$refs.count2.start();
        }
        if (this.$refs.count3) {
          this.$refs.count3.start();
        }
      });
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    startAutoPlay() {
      this.pauseAutoPlay();
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    pauseAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    handleKeydown(e) {
      if (e.key === 'ArrowLeft') {
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        this.nextSlide();
      }
    }
  }
}
</script>

<style scoped>
.rencaiBj {

  width: 200px;
  height: 200px;
  border-radius: 50%;

}

.rencaiBj img {
  object-fit: cover;
  transition: transform 0.3s ease;
}

.rencaiBj:hover img {
  transform: scale(1.1);
  cursor: pointer;
}

.team_bg {
  background: url(/src/images/index-rencai.png) no-repeat;
  width: 100%;
  height: 700px;
  background-size: cover;
}

.more_team {
  padding-top: 80px;
}

.more_team a {
  text-decoration: none;
  color: #2659b9;
  border: 1px solid #2659b9;
  border-radius: 50px;
  font-size: 14px;
  padding: 6px 15px;

}

.more_team:hover a {

  color: #ffffff;
  background: #2659b9;

}

.parter_bg {
  background: url(/src/images/index-hezuo.png) no-repeat;
  background-size: cover;
  width: 100%;
  height: 650px;
}

.com-bg1 {
  width: 180px;
  margin: auto;
  height: 300px;
  border: 2px solid #ffffff;
  position: relative;
  transition: background 0.4s ease;
}

.caseImg {
  width: 184px;
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
  display: grid;
  place-items: center;
}

.caseImg:hover {
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.content-bg {
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;

}

.com-bg1:hover .content-bg {

  cursor: pointer;

  background: rgb(5, 71, 194, 0.8);
}

.text-overflow {
  height: 300px;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}

.interBg {
  position: relative;
  background-attachment: fixed;
  background-image: url(/src/images/index-lei.png);
  height: 800px;
  overflow: hidden;
  background-size: cover;
}

.modle-overlay img {
  width: 70px;
}

.modle-overlay h2 {
  font-size: 20px;
  font-weight: normal;
  margin-top: 20px;
}

.modle-overlay .upper {
  margin-top: 10px;
  margin-bottom: 40px;
}

.modle-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0px;
  transition: background 0.4s ease;
  color: #ffffff;
}

.modle-overlay p a {
  color: #ffffff;
  text-decoration: none;
  font-weight: normal;
  font-size: 12px;
  border-radius: 20px;
  padding: 8px 20px;
  border: 1px solid #ffffff;
}

.modle:hover .modle-overlay {
  cursor: pointer;
  background: rgb(5, 71, 194, 0.8);
}

.modle-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: transform 0.5s ease;
}

.modle:hover .modle-bg {
  transform: scale(1.1);
}

.molde-1 .modle-bg {
  background-image: url(/src/images/f11.png);
}

.molde-2 .modle-bg {
  background-image: url(/src/images/f22.png);
}

.molde-3 .modle-bg {
  background-image: url(/src/images/f33.png);
}

.molde-4 .modle-bg {
  background-image: url(/src/images/f44.png);
}

.modle {
  flex: 1 1 calc(25%);
  position: relative;
  transition: transform 0.4s ease;
  min-width: 250px;
  height: 780px;
  overflow: hidden;
}

.about_bg {
  background: url(/src/images/abouts1.png) no-repeat;
  width: 100%;
}

.index-img {
  background-image: url(/src/images/index-b1.png);
  width: 100%;
  height: 300px;
}

.index-img1 {
  background-image: url(/src/images/index-b2.png);
  width: 100%;
  height: 300px;
}



.index-img2 {
  background-image: url(/src/images/index-b3.png);
  width: 100%;
  height: 300px;
}


.index-img3 {
  background-image: url(/src/images/index-b4.png);
  width: 100%;
  height: 300px;
}




.fixed-bg {
  background-image: url('https://www.goldstreaminvestment.cn/image/content/bgAI.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.fixed-bg h1 {
  color: white;
  font-size: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 全屏Banner容器 */
.banner {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 幻灯片容器 */
.slides {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 单个幻灯片 */
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  /* 确保所有幻灯片初始位置一致 */
  transform: translateX(0);
  transition: opacity 0.8s ease-in-out;
  pointer-events: none;
}

/* 当前活动幻灯片 */
.slide.active {
  opacity: 1;
  z-index: 3;
  pointer-events: auto;
}

/* 幻灯片背景图片 - 重新添加缩放效果但不晃动 */
.slide-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  /* 初始缩放为1.1，创建放大效果 */
  transform: scale(1.1);
  /* 只对transform属性应用过渡，避免位置变化 */
  transition: transform 10s ease-out;
}

/* 活动状态的背景图片缓慢缩放到正常大小 */
.slide.active .slide-bg {
  transform: scale(1);
}

/* 内容容器 */
.content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  padding: 0 40px;
  color: white;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease 0.3s;
}

.slide.active .content {
  opacity: 1;
  transform: translateY(0);
}

.content h2 {
  font-size: 5.5rem;
  margin-bottom: 10px;
  /* text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3); */
}

.content p {
  font-size: 1.3rem;
  margin-bottom: 30px;
  line-height: 1.6;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}



/* 导航按钮 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  /* background: rgba(255, 255, 255, 0.2); */
  background: transparent;
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  /* backdrop-filter: blur(5px); */
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn:hover {
  background: transparent;
  /* background: rgba(255, 255, 255, 0.3); */
  transform: translateY(-50%) scale(1.1);
}

.prev {
  left: 30px;
}

.next {
  right: 30px;
}

/* 指示器 */
.indicators {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  margin: 0 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: white;
  transform: scale(1.2);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content h2 {
    font-size: 2.5rem;
  }

  .content p {
    font-size: 1.1rem;
  }

  .nav-btn {
    width: 50px;
    height: 50px;
    font-size: 1.2rem;
  }

  .prev {
    left: 15px;
  }

  .next {
    right: 15px;
  }

  .fixed-bg h1 {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .content h2 {
    font-size: 2rem;
  }

  .content p {
    font-size: 1rem;
  }

  .content {
    padding: 0 20px;
  }

  .fixed-bg h1 {
    font-size: 2rem;
  }
}

.about_section {
  background: bottom url(/src/images/aboutbg.png);
  background-repeat: no-repeat;
  width: 100%;
  background-size: contain;
}
</style>